import { validateVoiceItem } from '../../../util/validateVoiceItem';

const validateVTex = ({ item }) => {
  const { vtex, type } = item;

  if (type === 'VTexCatalogProduct') {
    return true;
  }

  if (!vtex) {
    return false;
  }

  if (type === 'VTexCartProduct' && vtex.productIndex) {
    return true;
  }

  const { appKey, appToken } = vtex;
  if (!appKey || !appToken || appKey === '' || appToken === '') {
    return false;
  }
  return true;
};

const validateZendesk = ({ bot }) => {
  if (
    !bot.settings ||
    !bot.settings.zendeskTicket ||
    !bot.settings.zendeskTicket.apiToken ||
    !bot.settings.zendeskTicket.nameSpace
  ) {
    return false;
  }
  return true;
};

const validateJira = ({ bot }) => {
  if (
    !bot.settings ||
    !bot.settings.jiraSettings ||
    !bot.settings.jiraSettings.email ||
    !bot.settings.jiraSettings.tokenAPI ||
    !bot.settings.jiraSettings.nameSpace
  ) {
    return false;
  }
  return true;
};

const validateRDStation = ({ bot }) => {
  if (
    !bot.settings ||
    !bot.settings.rdStation ||
    !bot.settings.rdStation.auth ||
    !bot.settings.rdStation.auth.accessToken ||
    !bot.settings.rdStation.auth.expiresIn ||
    !bot.settings.rdStation.auth.refreshToken
  ) {
    return false;
  }

  return true;
};

const validateGlpi = ({ bot }) => {
  if (
    !bot.settings ||
    !bot.settings.glpiSettings ||
    !bot.settings.glpiSettings.apiUrl ||
    !bot.settings.glpiSettings.appToken ||
    !bot.settings.glpiSettings.userToken
  ) {
    return false;
  }
  return true;
};

export const validateSquareInfo = [
  {
    type: 'Human',
    message: 'Mensagem de erro no bloco avançado de atendimento humano',
    errorListTitle: 'Bloco de atendimento humano',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: ({ bot }) => {
      if (
        !bot.settings ||
        !bot.settings.human ||
        !bot.settings.human.endPoints ||
        !bot.settings.human.endPoints.start ||
        !bot.settings.human.endPoints.message ||
        !bot.settings.human.endPoints.status ||
        !bot.settings.human.endPoints.queue
      ) {
        return false;
      }
      return true;
    },
  },
  {
    type: 'Collect',
    message: 'Mensagem de erro no bloco avançado de coleta',
    errorListTitle: 'Bloco de coleta',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: ({ bot }) => {
      if (
        !bot.settings ||
        !bot.settings.storage ||
        !(
          bot.settings.storage.storage &&
          bot.settings.storage.project &&
          bot.settings.storage.key &&
          bot.settings.storage.key.length > 2
        )
      ) {
        return false;
      }
      return true;
    },
  },
  {
    type: 'SMS',
    message: 'Mensagem de erro no bloco avançado de SMS',
    errorListTitle: 'Bloco de SMS',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: ({ bot }) => {
      if (
        !bot.settings ||
        !bot.settings.sms ||
        !(
          bot.settings.sms.campaign &&
          bot.settings.sms.username &&
          bot.settings.sms.password
        )
      ) {
        return false;
      }
      return true;
    },
  },
  {
    type: 'EMAIL',
    message: 'Mensagem de erro no bloco avançado de email',
    errorListTitle: 'Bloco de e-mail',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: ({ bot }) => {
      if (
        !bot.settings ||
        !bot.settings.email ||
        !(
          bot.settings.email.host &&
          bot.settings.email.port &&
          bot.settings.email.username &&
          bot.settings.email.password
        )
      ) {
        return false;
      }
      return true;
    },
  },
  {
    type: 'VTexAddToCart',
    message: 'Mensagem de erro no bloco adicionar ao carrinho',
    errorListTitle: 'Bloco de adicionar ao carrinho',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVTex,
  },
  {
    type: 'VTexUpdateCart',
    message: 'Mensagem de erro no bloco atualizar ao carrinho',
    errorListTitle: 'Bloco de atualizar ao carrinho',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVTex,
  },
  {
    type: 'VTexRemoveFromCart',
    message: 'Mensagem de erro no bloco remover item do carrinho',
    errorListTitle: 'Bloco de remover item do carrinho',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVTex,
  },
  {
    type: 'VTexCatalogProduct',
    message: 'Mensagem de erro no bloco buscar produto do catálago',
    errorListTitle: 'Bloco de buscar produto do catálago',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVTex,
  },
  {
    type: 'VTexCatalogProducts',
    message: 'Mensagem de erro no bloco listar catálago',
    errorListTitle: 'Bloco de listar catálago',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVTex,
  },
  {
    type: 'VTexCartProduct',
    message: 'Mensagem de erro no bloco buscar produto do carrinho',
    errorListTitle: 'Bloco de buscar produto do carrinho',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVTex,
  },
  {
    type: 'VTexOrderList',
    message: 'Mensagem de erro no bloco listar carrinho',
    errorListTitle: 'Bloco de listar carrinho',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVTex,
  },
  {
    type: 'VTexCheckout',
    message: 'Mensagem de erro no bloco checkout',
    errorListTitle: 'Bloco de checkout',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVTex,
  },
  {
    type: 'ZendeskCreateRequest',
    message: 'Mensagem de erro no bloco nova requisição',
    errorListTitle: 'Bloco de nova requisição',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateZendesk,
  },
  {
    type: 'ZendeskListRequests',
    message: 'Mensagem de erro no bloco listar requisições',
    errorListTitle: 'Bloco de listar requisições',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateZendesk,
  },
  {
    type: 'ZendeskShowRequest',
    message: 'Mensagem de erro no bloco mostrar requisições',
    errorListTitle: 'Bloco de mostrar requisições',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateZendesk,
  },
  {
    type: 'ZendeskShowRequest',
    message: 'Mensagem de erro no bloco mostrar requisições',
    errorListTitle: 'Bloco de mostrar requisições',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateZendesk,
  },
  {
    type: 'ZendeskListComments',
    message: 'Mensagem de erro no bloco listar comentários',
    errorListTitle: 'Bloco de listar comentários',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateZendesk,
  },
  {
    type: 'ZendeskInsertComment',
    message: 'Mensagem de erro no bloco inserir comentário',
    errorListTitle: 'Bloco de inserir comentário',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateZendesk,
  },
  {
    type: 'ZendeskAttachFile',
    message: 'Mensagem de erro no bloco anexar arquivo',
    errorListTitle: 'Bloco de anexar arquivo',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateZendesk,
  },
  {
    type: 'ZendeskUpdateStatusRequest',
    message: 'Mensagem de erro no bloco atualizar status',
    errorListTitle: 'Bloco de atualizar status',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateZendesk,
  },
  {
    type: 'VoiceTransferirRamalInternoExterno',
    message: 'Configurações incompletas',
    errorListTitle: 'Bloco Transf. Ramal',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVoiceItem,
  },
  {
    type: 'VoiceTTSAudio',
    message: 'Configurações incompletas',
    errorListTitle: 'Bloco Tocar Áudio',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVoiceItem,
  },
  {
    type: 'VoiceConfirmarVenda',
    message: 'Configurações incompletas',
    errorListTitle: 'Bloco de Venda',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVoiceItem,
  },
  {
    type: 'VoiceTTSAudioASR',
    message: 'Configurações incompletas',
    errorListTitle: 'Bloco de Áudio + Reconhecimento de Voz',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVoiceItem,
  },
  {
    type: 'VoiceFinalizarAtendimento',
    message: 'Configurações incompletas',
    errorListTitle: 'Bloco de Finalizar Atendimento',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVoiceItem,
  },
  {
    type: 'VoiceTransferirRamalLocalizadorVendedor',
    message: 'Configurações incompletas',
    errorListTitle: 'Bloco de Transf. Operador',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVoiceItem,
  },
  {
    type: 'VoiceAgendarMailing',
    message: 'Configurações incompletas',
    errorListTitle: 'Bloco de Agendar Ligação',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVoiceItem,
  },
  {
    type: 'VoiceTTSAudioDTMF',
    message: 'Configurações incompletas',
    errorListTitle: 'Bloco de Áudio + Reconhecimento Dígitos',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVoiceItem,
  },
  {
    type: 'VoiceWebApiList',
    message: 'Configurações incompletas',
    errorListTitle: 'Bloco API',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVoiceItem,
  },
  {
    type: 'VoiceSMS',
    message: 'Configurações incompletas',
    errorListTitle: 'Bloco de Enviar SMS',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVoiceItem,
  },
  {
    type: 'VoicePesquisarMailing',
    message: 'Configurações incompletas',
    errorListTitle: 'Bloco de Pesquisar Mailing',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVoiceItem,
  },
  {
    type: 'VoiceInserirMailing',
    message: 'Configurações incompletas',
    errorListTitle: 'Bloco de ASR',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVoiceItem,
  },
  {
    type: 'VoiceEmail',
    message: 'Configurações incompletas',
    errorListTitle: 'Bloco de Email',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVoiceItem,
  },
  {
    type: 'VoicePularStep',
    message: 'Configurações incompletas',
    errorListTitle: 'Bloco de Pular Step',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateVoiceItem,
  },
  {
    type: 'JiraCreateIssue',
    message: 'Mensagem de erro no bloco novo ticket',
    errorListTitle: 'Bloco de criar ticket',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateJira,
  },
  {
    type: 'JiraListIssues',
    message: 'Mensagem de erro no bloco listar tockets',
    errorListTitle: 'Bloco de listar tickets',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateJira,
  },
  {
    type: 'JiraShowIssue',
    message: 'Mensagem de erro no bloco checar ticket',
    errorListTitle: 'Bloco de checar ticket',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateJira,
  },
  {
    type: 'JiraListProjects',
    message: 'Mensagem de erro no bloco listar projetos',
    errorListTitle: 'Bloco de listar projetos',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateJira,
  },
  {
    type: 'JiraListStatus',
    message: 'Mensagem de erro no bloco listar status',
    errorListTitle: 'Bloco de listar status',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateJira,
  },
  {
    type: 'JiraListRequestypes',
    message: 'Mensagem de erro no bloco listar tipos ticket',
    errorListTitle: 'Bloco de listar tipos ticket',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateJira,
  },
  {
    type: 'JiraListPriorities',
    message: 'Mensagem de erro no bloco listar prioridades',
    errorListTitle: 'Bloco de listar prioridades',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateJira,
  },
  {
    type: 'JiraListComments',
    message: 'Mensagem de erro no bloco listar comemtários',
    errorListTitle: 'Bloco de listar comentários',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateJira,
  },
  {
    type: 'JiraInsertComment',
    message: 'Mensagem de erro no bloco inserir comentário',
    errorListTitle: 'Bloco de inserir comentário',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateJira,
  },
  {
    type: 'JiraAttachFile',
    message: 'Mensagem de erro no bloco anexar arquivo',
    errorListTitle: 'Bloco de anexar arquivo',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateJira,
  },
  {
    type: 'JiraUpdateStatusIssue',
    message: 'Mensagem de erro no bloco finalizar ticket',
    errorListTitle: 'Bloco de finalizar ticket',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateJira,
  },
  {
    type: 'RdStationInput',
    message: 'Erro no bloco Campo na integração com RD Station',
    errorListTitle: 'Bloco de campo da RD Station',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateRDStation,
  },
  {
    type: 'RdStationSubmitLead',
    message: 'Erro no bloco Criar lead na integração com RD Station',
    errorListTitle: 'Bloco de criação de lead da RD Station',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateRDStation,
  },
  {
    type: 'MenuAI',
    message: 'Mensagem de erro no bloco de Menu IA',
    errorListTitle: 'Bloco de Menu IA',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: ({ bot }) => bot?.ia?.platforms?.length !== 0,
  },
  {
    type: 'GlpiCreateRequest',
    message: 'Mensagem de erro no bloco nova requisição',
    errorListTitle: 'Bloco de nova requisição',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateGlpi,
  },
  {
    type: 'GlpiListRequests',
    message: 'Mensagem de erro no bloco listar requisições',
    errorListTitle: 'Bloco de listar requisições',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateGlpi,
  },
  {
    type: 'GlpiShowRequest',
    message: 'Mensagem de erro no bloco mostrar requisições',
    errorListTitle: 'Bloco de mostrar requisições',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateGlpi,
  },
  {
    type: 'GlpiShowRequest',
    message: 'Mensagem de erro no bloco mostrar requisições',
    errorListTitle: 'Bloco de mostrar requisições',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateGlpi,
  },
  {
    type: 'GlpiListComments',
    message: 'Mensagem de erro no bloco listar comentários',
    errorListTitle: 'Bloco de listar comentários',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateGlpi,
  },
  {
    type: 'GlpiInsertComment',
    message: 'Mensagem de erro no bloco inserir comentário',
    errorListTitle: 'Bloco de inserir comentário',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateGlpi,
  },
  {
    type: 'GlpiAttachFile',
    message: 'Mensagem de erro no bloco anexar arquivo',
    errorListTitle: 'Bloco de anexar arquivo',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateGlpi,
  },
  {
    type: 'GlpiUpdateStatusRequest',
    message: 'Mensagem de erro no bloco atualizar status',
    errorListTitle: 'Bloco de atualizar status',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateGlpi,
  },
  {
    type: 'GlpiListGroups',
    message: 'Mensagem de erro no bloco listar grupos',
    errorListTitle: 'Bloco de listar grupos',
    linkKnowMore: 'https://code7.com/faq/boteria',
    validate: validateGlpi,
  },
];
